module.exports = __webpack_public_path__ + "static/media/ring_blue.b872b7f5.png";